import { Component } from '@angular/core';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { DialogManager } from '../../global/dialog-manager/dialog';
import { CalendarPickerComponent } from '../../shared/components/forms/calendar-picker/calendar-picker.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-demo',
  imports: [ButtonComponent, CalendarPickerComponent, FormsModule],
  templateUrl: './demo.component.html',
  styleUrl: './demo.component.scss',
})
export class DemoComponent {
  loading = false;

  todayDate = new Date();
  test: any;
  constructor() {
    setTimeout(() => {
      this.loading = true;
    }, 5000);

    setTimeout(() => {
      this.loading = false;
    }, 10000);
  }
  loadConfirmDialog(): void {
    DialogManager.openConfirmDialog().closed.subscribe({
      next: (value: any) => {
        console.log('closed with value', value);
      },
    });
  }

  loadRetryDialog(): void {
    DialogManager.openRetryDialog().closed.subscribe({
      next: (value: any) => {
        console.log('closed with value', value);
      },
    });
  }

  loadTemplateDialog(template: any): void {
    DialogManager.openDialog(template, {
      disableClose: false,
    }).closed.subscribe({
      next: (value: any) => {
        console.log('closed with value', value);
      },
    });
  }
}
